import "./NlpChatHeader.css";
import React, { useState } from "react";

const statuses = [
    "הכל",
    "הודעות שלא נקראו",
    "הודעות שלא טופלו",
    "הודעות שנקראו"
];

const NlpChatHeader: React.FC = () => {
    const [selectedStatus, setSelectedStatus] = useState("הכל");

    return (
        <div className="NlpChatHeader">
            <div className="NlpChatHeader__customer-name-and-date">
                <div className="customer-name">יפעת שמואלי</div>
                <div className="customer-date">יום חמישי, 24 באפריל 2025</div>
            </div>

            <div className="NlpChatHeader__message-statuses">
                {statuses.map((status) => (
                    <button
                        key={status}
                        className={`status-button ${selectedStatus === status ? "selected" : ""}`}
                        onClick={() => setSelectedStatus(status)}
                    >
                        {status}
                    </button>
                ))}
            </div>

            <div className="NlpChatHeader__ip">
                🌍
                <span className="ip-address">34.34.242.73</span>
            </div>
        </div>
    );
};

export default NlpChatHeader;
